import { createApi } from '@reduxjs/toolkit/query/react'
import queryString from 'query-string';
import { IEmployee } from '../../types'
import axiosBaseQuery from './API'


// Define a service using a base URL and expected endpoints
export const employeeApi = createApi({
  reducerPath: 'employeeApi',
  tagTypes: ['EmployeeApi'],
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    getEmployee: builder.query<any, {}>({
      query: (data:any) => {
        const stringified = queryString.stringify(data);
        return  {url:`team-member/all/?${stringified}`, method:'GET'}
      },
      providesTags: [{ type: 'EmployeeApi' }],
    }),
    addEmployee: builder.mutation<any, Partial<any>>({
      query(body) {        
        return {
          url: `team-member/`,
          method: 'POST',
          data:body,
        }
      },
      invalidatesTags: [{ type: 'EmployeeApi'}],
    }), 
    getEmployeeById: builder.query<any, {}>({
        query: (data:any) => {
          return  {url:`team-member/${data.id}/`, method:'GET'}
        },
        providesTags: [{ type: 'EmployeeApi' }],
      }), 
    editEmployee: builder.mutation<any, Partial<any>>({
        query(body) {       
            const {id, ...rest} =body
          return {
            url: `team-member/${id}`,
            method: 'PUT',
            data:rest,
          }
        },
        invalidatesTags: [{ type: 'EmployeeApi'}],
      }),  
    deleteEmployee: builder.mutation<any, {id:number | null}>({
      query({id}) {        
        return {
          url: `team-member/${id}/`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [{ type: 'EmployeeApi'}],
    }), 
  }),
  
})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
    useGetEmployeeQuery, 
    useGetEmployeeByIdQuery,
    useDeleteEmployeeMutation,
    useEditEmployeeMutation, 
    useAddEmployeeMutation,

 } = employeeApi
